import React from 'react';

import { useEnrichPaymentsWithUserData } from '~/hooks/apis/vendors/useVendorOfferPayments';

import VendorOfferPaymentsList from './VendorOfferPaymentsList';

interface Props {
  data: {
    result: Array<Record<string, unknown>>;
  };
  searchTerm?: string;
}

export default function VendorOfferPaymentsListContainer({ data, searchTerm }: Props) {
  const { data: payments = data.result, isLoading } = useEnrichPaymentsWithUserData({
    payments: data.result,
    userField: 'fk_added_by',
  });

  let filteredPayments;
  // search by payment amount if the search string fits the payment amount format
  if (searchTerm?.match(/\d+\.00/i)) {
    filteredPayments = payments.filter((payment) => payment.cost_amount === searchTerm);
  } else {
    filteredPayments = !searchTerm ? payments : payments.filter((payment) => payment.description?.includes(searchTerm));
  }

  return <VendorOfferPaymentsList isLoading={isLoading} payments={filteredPayments} />;
}
